import Icon from '../components/Icon.vue'

Icon.register({
  'map-marker': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M172.3 501.7C27 291 0 269.4 0 192 0 86 86 0 192 0S384 86 384 192C384 269.4 357 291 211.7 501.7 202.2 515.4 181.8 515.4 172.3 501.7z'
      }
    ]
  }
})
